﻿import React from 'react';
import { Breadcrumbs as BpBreadcrumbs, Breadcrumb } from "@blueprintjs/core";
import classNames from 'classnames';
import PropTypes from 'prop-types';

export function QuestionBreadcrumb({ templateLayout, questionId, loading }) {
    if (!templateLayout?.pages?.length) return null;
    function findBreadcrumbPath(pages, targetId) {
        let questionCounter = 1;

        function traverse(components, path = []) {
            for (const component of components) {
                const children = component.childComponents || [];
                const isQuestion = typeof component.$componentType === 'string' && component.$componentType.endsWith('Question');

                let title = component.title || '';

                if (isQuestion) {
                    const currentQuestionNumber = questionCounter;
                    questionCounter++;
                    title = `Question ${currentQuestionNumber}`;
                    const updatedPath = [...path, { title }];

                    if (component.id === targetId) {
                        return updatedPath;
                    }

                    const result = traverse(children, updatedPath);
                    if (result) return result;
                } else {
                    const updatedPath = [...path, { title }];
                    const result = traverse(children, updatedPath);
                    if (result) return result;
                }
            }

            return null;
        }

        return traverse(pages);
    }

    const breadcrumbPath = findBreadcrumbPath(templateLayout.pages, questionId);

    if (!breadcrumbPath) return <span>Question not found</span>;

    return (
        <div className={classNames({ "bp6-skeleton": loading }, "breadcrumbs")}>
            <BpBreadcrumbs
                items={breadcrumbPath}
                breadcrumbRenderer={(item) => <span className="bp6-breadcrumb">{item.title}</span>}
                currentBreadcrumbRenderer={(item) => <Breadcrumb text={item.title} />}
            />
        </div>
    );
}

QuestionBreadcrumb.propTypes = {
    templateLayout: PropTypes.shape({
        pages: PropTypes.array
    }),
    questionId: PropTypes.string,
    loading: PropTypes.bool
};
